<template>
    <div>
        <!-- Service Title -->
        <div v-if="$slots.title" class="row pb-4">
            <div class="col">
                <h1><slot name="title"></slot></h1>
            </div>
        </div>

        <!-- Service Filter -->
        <div v-if="$slots.filter" class="row pb-4 d-none d-none d-lg-block">
            <div class="col">
                <slot name="filter"></slot>
            </div>
        </div>

        <!-- Service Data -->
        <div class="row">
            <!-- Fetching Data -->
            <div class="col" v-show="!retrieved">
                <div class="sau-bx bx-pad">
                    <div class="text-center">
                        <img src="/img/spinner.gif" />
                        <h6 class="sau-pm-reset">
                            Fetching <slot name="fetching"></slot>
                        </h6>
                    </div>
                </div>
            </div>

            <!-- Data Received -->
            <div v-show="retrieved" class="col">
                <slot name="data"></slot>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
	props: ['retrieved'],
	data() {
	    return {
	    };
	},
    }
</script>
